import type { NodeRecord } from '@flobi/artwork-core';
import type { AgentItem } from '@flobi/asset-library/agent';

/** A layer as the agent panel shows it: its name (its type when it has none) and its type. */
export const layerItem = (node: NodeRecord): AgentItem => ({
  kind: 'layer',
  id: node.id,
  title: node.name || node.type[0]!.toUpperCase() + node.type.slice(1),
  detail: node.type,
});

/** What the agent context says about where the editor is: the file open, read from the address at send time. */
export function editorContext(pathname: string): { docId?: string } {
  const open = /^\/f\/([^/]+)/.exec(pathname);
  return open ? { docId: decodeURIComponent(open[1]!).toLowerCase() } : {};
}
